<template>
    <div class="justify-end">
        <v-btn
            text
            :class="{ 'pr-4': $vuetify.breakpoint.smAndUp }"
            :ripple="false"
            @click.prevent="toggleFilterPopup()" 
        >
            <v-icon
                class="icon icon-horizontal-slider"
                :left="!$vuetify.breakpoint.xs"
            />
            <span
                v-if="!$vuetify.breakpoint.xs"
                class="habiteo-body-2 text-none"
            >
                {{ $t('sidebar.section.filters')}}
            </span>
        </v-btn>
        <CutawayFiltersPopup 
            :data="data" 
            :filterPopup="filterPopup" 
            @toogle-filter-popup="toggleFilterPopup()"
        />
        <ToggleViewButton
            class="d-inline-block"
            :widget="activeWidget"
        />
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';

    import CutawayFiltersPopup from "@/layout/alternative/cutaway/components/CutawayFiltersPopup";
    import ToggleViewButton from '@/components/cutawayHeader/components/ToggleViewButton';

    export default {
        name: "CutawayLayout",
        components: {
            CutawayFiltersPopup,
            ToggleViewButton
        },
        props: ["data"],
        data() {
            return {
                filterPopup: false,
                activeWidget: "cutaway"
            };
        },
        mounted(){
            this.activeWidget = this.$props.data.type === 'cutaway' ? this.activeWidget : 'plot-grid';
            EventBus.$on('switchSidebar', widget => {
                this.activeWidget = widget;
                this.$props.data.type = widget;
            });
        },
        methods: {
            toggleFilterPopup(){
                this.filterPopup = !this.filterPopup;
            }, 
        }
    };
</script>


// WEBPACK FOOTER //
// src/layout/alternative/cutaway/CutawayHeader.vue